import {register} from 'register-service-worker';

const checkForUpdates = (registration) => {
	if (registration && registration.update) {
		registration.update();
	}
}

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready(registration) {
            // Start checking for updates every 5 minutes
            setInterval(() => checkForUpdates(registration), 5 * 60 * 1000); // 5 minutes
        },
        registered() {},
        cached() {},
        updatefound() {},
        updated(registration) {
            let refreshing = false;
            if (navigator.serviceWorker) {
                navigator.serviceWorker.addEventListener('controllerchange', () => {
                    if (refreshing) return;
                    refreshing = true;
                    window.location.reload();
                });
            }

            // Send a message to the new service worker to activate it
            if (registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
        },
        offline() {},
        error(error) {
            console.error('Error during service worker registration:', error);
        },
    })
}